import {CATCH_ALL_ROUTE, SIGN_IN_ROUTE, SLUG_CAPTURE} from '../../../shared/constants/routes';
import {__REWRITE__} from '../../../shared/enhancers/router-enhancer';

export const routes = {
  [SIGN_IN_ROUTE]: (match, props, prevRouteContext) => ({
    ...prevRouteContext,
    signin: true
  }),
  [`^/stackups/${SLUG_CAPTURE}/!/(.*)$`]: match => ({
    routeAction: match[2],
    toolSlugs: match[1].split('-vs-'),
    [__REWRITE__]: `/stackups/${match[1]}`
  }),
  [`^/stackups/${SLUG_CAPTURE}$`]: match => ({
    toolSlugs: match[1].split('-vs-')
  }),
  [`^/stackups/${SLUG_CAPTURE}/mobile_experiment`]: match => ({
    routeAction: match[2],
    toolSlugs: match[1].split('-vs-'),
    [__REWRITE__]: `/stackups/${match[1]}/mobile_experiment`
  }),
  [CATCH_ALL_ROUTE]: () => ({toolSlugs: []})
};
